const crashlytics = () => {
  return {
    setUserId: (_: string): void => {},
    log: (_: string): void => {},
  };
};
export default crashlytics;
